import { IBlockQuote } from '@seb/web-design-system/blockquote';

export const blockQuoteSkeleton: IBlockQuote = {
  quote: 'quote',
  author: 'author',
  quoteImg: { url: 'url' }
};
